// extracted by mini-css-extract-plugin
export default {"servicePaginationCard":"service-pagination-card_servicePaginationCard__M-Q2F"};